module.exports = __webpack_public_path__ + "img/step2.219d6ae6.png";